var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// 环境配置加载器
import { environment as devEnvironment } from './environments/environment.dev';
import { environment as testEnvironment } from './environments/environment.test';
import { environment as prodEnvironment } from './environments/environment.prod';
// 获取环境变量，默认为 dev
var getEnvironment = function () {
    // 从webpack DefinePlugin注入的环境变量获取
    return process.env.NODE_ENV_TARGET || 'dev';
};
// 根据环境变量选择对应的配置
var getCurrentEnvironment = function () {
    var env = getEnvironment().toLowerCase();
    switch (env) {
        case 'test':
            return testEnvironment;
        case 'prod':
            return prodEnvironment;
        case 'dev':
        default:
            return devEnvironment;
    }
};
// 导出当前环境的配置
export var environment = getCurrentEnvironment();
// 导出环境检查函数
export var isDevelopment = function () { return environment.environment === 'dev'; };
export var isTest = function () { return environment.environment === 'test'; };
export var isProduction = function () { return environment.environment === 'prod'; };
// 导出日志函数（根据环境配置控制日志输出）
export var log = {
    debug: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (environment.enableDebug && (environment.logLevel === 'debug')) {
            console.log.apply(console, __spreadArray(['[DEBUG]'], args, false));
        }
    },
    info: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (environment.logLevel === 'debug' || environment.logLevel === 'info') {
            console.info.apply(console, __spreadArray(['[INFO]'], args, false));
        }
    },
    warn: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (environment.logLevel !== 'error') {
            console.warn.apply(console, __spreadArray(['[WARN]'], args, false));
        }
    },
    error: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.error.apply(console, __spreadArray(['[ERROR]'], args, false));
    }
};
